const assets = [
  { symbol: 'BTCUSDT', oosReturn: '+18.7%', sharpe: '1.24', maxDD: '-8.2%', status: 'pass', color: '#22c55e' },
  { symbol: 'ETHUSDT', oosReturn: '+14.3%', sharpe: '0.98', maxDD: '-11.4%', status: 'pass', color: '#22c55e' },
  { symbol: 'SOLUSDT', oosReturn: '+9.1%', sharpe: '0.72', maxDD: '-14.8%', status: 'pass', color: '#22c55e' },
  { symbol: 'AVAXUSDT', oosReturn: '+3.2%', sharpe: '0.31', maxDD: '-18.6%', status: 'warn', color: '#f59e0b' },
  { symbol: 'LINKUSDT', oosReturn: '-2.4%', sharpe: '-0.18', maxDD: '-22.1%', status: 'fail', color: '#ef4444' },
];

const aggregate = {
  medianReturn: '+9.1%',
  worstReturn: '-2.4%',
  medianDD: '-14.8%',
  passRate: '3/5',
};

export default function MultiAssetWFAMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Multi-Asset WFA Results</div>
      <div className="platform-mock-body">
        <table style={{ width: '100%', fontSize: '0.65rem', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ color: '#64748b', textAlign: 'left' }}>
              <th style={{ padding: '0.3rem 0.4rem', fontWeight: 500 }}>Asset</th>
              <th style={{ padding: '0.3rem 0.4rem', fontWeight: 500, textAlign: 'right' }}>OOS Return</th>
              <th style={{ padding: '0.3rem 0.4rem', fontWeight: 500, textAlign: 'right' }}>Sharpe</th>
              <th style={{ padding: '0.3rem 0.4rem', fontWeight: 500, textAlign: 'right' }}>Max DD</th>
              <th style={{ padding: '0.3rem 0.4rem', fontWeight: 500, textAlign: 'center' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {assets.map((a) => (
              <tr key={a.symbol} style={{ borderTop: '1px solid #1e293b' }}>
                <td style={{ padding: '0.35rem 0.4rem', color: '#e2e8f0', fontWeight: 500 }}>{a.symbol}</td>
                <td style={{ padding: '0.35rem 0.4rem', textAlign: 'right', color: a.color, fontFamily: 'monospace' }}>{a.oosReturn}</td>
                <td style={{ padding: '0.35rem 0.4rem', textAlign: 'right', color: '#94a3b8', fontFamily: 'monospace' }}>{a.sharpe}</td>
                <td style={{ padding: '0.35rem 0.4rem', textAlign: 'right', color: '#94a3b8', fontFamily: 'monospace' }}>{a.maxDD}</td>
                <td style={{ padding: '0.35rem 0.4rem', textAlign: 'center' }}>
                  <span style={{
                    display: 'inline-block',
                    width: 18,
                    height: 18,
                    lineHeight: '18px',
                    textAlign: 'center',
                    borderRadius: '50%',
                    fontSize: '0.55rem',
                    fontWeight: 700,
                    color: a.color,
                    background: `${a.color}18`,
                  }}>
                    {a.status === 'pass' ? 'P' : a.status === 'warn' ? '!' : 'F'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '0.5rem',
          marginTop: '0.75rem',
          padding: '0.5rem',
          background: '#0f172a',
          borderRadius: 6,
        }}>
          {[
            { label: 'Median Return', value: aggregate.medianReturn, color: '#22c55e' },
            { label: 'Worst Return', value: aggregate.worstReturn, color: '#ef4444' },
            { label: 'Median Max DD', value: aggregate.medianDD, color: '#f59e0b' },
            { label: 'Pass Rate', value: aggregate.passRate, color: '#3b82f6' },
          ].map((m) => (
            <div key={m.label} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '0.85rem', fontWeight: 700, color: m.color, fontFamily: 'monospace' }}>{m.value}</div>
              <div style={{ fontSize: '0.55rem', color: '#64748b', marginTop: 2 }}>{m.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="platform-mock-caption">Multi-asset WFA tests the same parameters across multiple markets to validate cross-asset robustness.</div>
    </div>
  );
}
